<template>
  <div class="register-steps">
    <ul>
      <li :class="{active: step === 1}">
        <a href="#" @click.prevent="changeStep(1)">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path d="M24 0L4 16.5v22.5C4 44 8 48 13 48h22C40 48 44 44 44 39V16.5L24 0zM28 46h-8V34h8V46zM42 39C42 42.9 38.9 46 35 46H30V32H18v14h-5C9.1 46 6 42.9 6 39V17.5L24 2.6l18 14.9V39z"></path></svg>
          <h4 class="d-none d-sm-block">1. Company<br> Information</h4>
        </a>
      </li>
      <li :class="{active: step === 2}">
        <a href="#" @click.prevent="changeStep(2)" data-title="Please configurate your solutions." data-subtitle="Choose your merchant solutions and compare pricings.">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path d="M7.6 1.6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6S10.9 1.6 7.6 1.6zM7.6 11.6c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4S9.8 11.6 7.6 11.6z" class="a"></path><path d="M7.6 17.6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6S10.9 17.6 7.6 17.6zM7.6 27.6c-2.2 0-4-1.8-4-4 0-2.2 1.8-4 4-4s4 1.8 4 4C11.6 25.8 9.8 27.6 7.6 27.6z" class="a"></path><path d="M23.6 1.6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6S26.9 1.6 23.6 1.6zM23.6 11.6c-2.2 0-4-1.8-4-4s1.8-4 4-4c2.2 0 4 1.8 4 4S25.8 11.6 23.6 11.6z" class="a"></path><path d="M23.6 17.6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6S26.9 17.6 23.6 17.6zM23.6 27.6c-2.2 0-4-1.8-4-4 0-2.2 1.8-4 4-4 2.2 0 4 1.8 4 4C27.6 25.8 25.8 27.6 23.6 27.6z" class="a"></path><path d="M39.6 17.6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6S42.9 17.6 39.6 17.6zM39.6 27.6c-2.2 0-4-1.8-4-4 0-2.2 1.8-4 4-4s4 1.8 4 4C43.6 25.8 41.8 27.6 39.6 27.6z" class="a"></path><path d="M7.6 33.6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6S10.9 33.6 7.6 33.6zM7.6 43.6c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4S9.8 43.6 7.6 43.6z" class="a"></path></svg>
          <h4 class="d-none d-sm-block">2. Solutions<br> Configuration</h4>
        </a>
      </li>
      <li :class="{active: step === 3}">
        <a href="#" @click.prevent="changeStep(3)" data-title="Please complete your registration." data-subtitle="In order to יִnally setup your merchant account please enter your data.">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path d="M39 40H9c-5 0-9-4-9-9V8h48v23C48 36 44 40 39 40zM2 10v21c0 3.9 3.1 7 7 7h30c3.9 0 7-3.1 7-7V10H2z"></path><rect x="6" y="28" width="4" height="4"></rect><rect x="38" y="28" width="4" height="4"></rect><rect x="6" y="14" width="4" height="4"></rect><rect x="14" y="14" width="4" height="4"></rect><rect x="22" y="14" width="4" height="4"></rect><rect x="10" y="21" width="4" height="4"></rect><rect x="18" y="21" width="4" height="4"></rect><rect x="26" y="21" width="4" height="4"></rect><rect x="34" y="21" width="4" height="4"></rect><rect x="38" y="14" width="4" height="4"></rect><rect x="30" y="14" width="4" height="4"></rect><rect x="14" y="28" width="20" height="4"></rect></svg>
          <h4 class="d-none d-sm-block">3. Financial <br>Data</h4>
        </a>
      </li>
      <li :class="{active: step === 4}">
        <a href="#" @click.prevent="changeStep(4)">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path d="M37 48H11C4.9 48 0 43.1 0 37V0h48v37C48 43.1 43.1 48 37 48zM2 2v35c0 5 4 9 9 9h26c5 0 9-4 9-9V2H2z"></path><rect x="10" y="8" width="28" height="2"></rect><polygon points="23.5 37.3 13.3 27.1 14.7 25.7 23.1 34 33.1 16.6 34.9 17.6 "></polygon></svg>
          <h4 class="d-none d-sm-block">4. Account<br> Setup Done!</h4>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'register-steps',
  computed: {
    ...mapFields({
      step: 'registration.step'
    })
  },
  methods: {
    changeStep(step) {
      this.$store.commit('changeRegisterStep', step)
    }
  }
}
</script>
